import React from "react";
import { string, func, bool } from "prop-types";
import { Link } from "@quintype/components";

import "./read-more.m.css";

const ReadMore = ({ href, onClick, loading }) =>
  onClick ? (
    <div styleName="read-more load-more-button">
      <button styleName="text load-more-text" onClick={onClick}>
        {loading ? "loading..." : "load more stories"}
      </button>
    </div>
  ) : (
    <Link href={href} styleName="read-more" className="read-more-button">
      <div styleName="text"> Read more </div>
    </Link>
  );

ReadMore.propTypes = {
  href: string,
  onClick: func,
  loading: bool
};

ReadMore.defaultProps = {
  loading: false
};

export default ReadMore;
